import { useCallback, useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import { Context } from "types/generated";
import { ContextSuggestions } from "shared/Context/constants";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import useContextsAnalytics from "../../useContextsAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const ContextsTableSpaceCell = ({ item: context, ...cellProps }: TableSimpleCellProps<Context>) => {
  const trackAnalytics = useContextsAnalytics();

  const spaceFilterAction = useCellFilterAction({
    filterName: ContextSuggestions.Space,
    filterValue: context.spaceDetails.id,
    spaceCell: true,
  });

  const handlePress = useCallback(() => {
    trackAnalytics("Space link clicked");
  }, [trackAnalytics]);

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellSpace href={`/spaces/${context.spaceDetails.id}`} onPress={handlePress}>
        {context.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default ContextsTableSpaceCell;
